/**
 *
 * Socket Notifications
 *
 */

import { io } from "socket.io-client";

class SocketNotification {
	socket: any;
	connected: boolean = false;
	connecting: boolean = false;

	initiateSocket({ source, user, token }: { source: string; user: string; token?: string }) {
		return new Promise((resolve) => {
			if ((this.connected || this.connecting) && this.socket) {
				return resolve(true);
			}

			this.connecting = true;

			const apiUrl = process.env.API_URL || "";
			let apiLink = apiUrl;
			let socketPath = "/api/socket";
			const isLocalhost =
				typeof window !== "undefined" && ["localhost", "127.0.0.1"].includes(window.location.hostname);

			try {
				const parsed = new URL(apiUrl);
				apiLink = parsed.origin;
				socketPath = `${parsed.pathname.replace(/\/+$/, "")}/socket`;
			} catch (e) {
				// Keep defaults if API_URL is not an absolute URL.
			}

			// prefer token passed from caller (Redux); fallback to session/local storage keys
			const resolvedToken =
				token ||
				(typeof window !== "undefined"
					? localStorage.getItem("token") ||
					  localStorage.getItem("authToken") ||
					  sessionStorage.getItem("session:authToken")
					: null);

			// @ts-ignore
			this.socket = io(apiLink, {
				path: socketPath,
				forceNew: true,
				transports: isLocalhost ? ["polling"] : ["polling", "websocket"],
				auth: {
					token: resolvedToken,
					source,
					user
				},
				timeout: 60000,
				autoConnect: true,
				reconnection: true,
				reconnectionDelay: 5000,
				reconnectionDelayMax: 10000
			});

			this.socket.on("connect", () => {
				this.connected = true;
				this.connecting = false;
				resolve(true);
			});

			this.socket.on("disconnect", (reason: any) => {
				this.connected = false;
				this.connecting = false;
				resolve(false);
			});

			this.socket.on("connect_error", (reason: any) => {
				this.connected = false;
				this.connecting = false;
			});

			this.socket.on("connect_timeout", () => {
				this.connected = false;
				this.socket?.connect();
			});
		});
	}

	close() {
		this.socket?.close();
		this.socket = null;
		this.connected = false;
		this.connecting = false;
	}

	get status() {
		return this.socket;
	}

	get isConnected() {
		return this.connected;
	}
}

const instance = new SocketNotification();
export default instance;
